export const TID = {
  // Auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  loginRegisterLink: "login-register-link",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerSubmit: "register-submit-button",
  registerLoginLink: "register-login-link",
  twofaCode: "2fa-code-input",
  twofaSubmit: "2fa-submit-button",
  twofaCancel: "2fa-cancel-button",

  // Layout
  brandLogo: "brand-logo",
  navDashboard: "nav-dashboard-link",
  navFinance: "nav-finance-link",
  navAssets: "nav-assets-link",
  navHR: "nav-hr-link",
  navSpreadsheets: "nav-spreadsheets-link",
  navSettings: "nav-settings-link",
  navSecurity: "nav-security-link",
  navSearch: "nav-search-link",
  topbarSearch: "global-search-input",
  topbarUser: "topbar-user-menu",
  topbarLogout: "topbar-logout-button",
  topbarProfile: "topbar-profile-link",

  // Dashboard
  kpiCard: (k) => `kpi-card-${k}`,
  kpiValue: (k) => `kpi-value-${k}`,

  // Finance
  invoiceRow: (id) => `invoice-row-${id}`,
  billRow: (id) => `bill-row-${id}`,

  // Assets
  assetRow: (id) => `asset-row-${id}`,
  assetFilterStatus: "asset-filter-status",
  assetFilterCategory: "asset-filter-category",
  assetSearch: "asset-search-input",

  // Capital Planning
  capitalClientSelect: "capital-client-select",
  capitalTabOverview: "capital-tab-overview",
  capitalTabRenewal: "capital-tab-renewal",
  capitalTabImmediate: "capital-tab-immediate",
  capitalTab12M: "capital-tab-12m",
  capitalTab24M: "capital-tab-24m",
  capitalTabDeferred: "capital-tab-deferred",
  capitalTabScenarios: "capital-tab-scenarios",
  capitalTabAssetClass: "capital-tab-asset-class",
  capitalTabSite: "capital-tab-site",
  capitalTabForecast: "capital-tab-forecast",
  capitalTabBoard: "capital-tab-board",
  capitalKPI: (k) => `capital-kpi-${k}`,
  capitalAssetRow: (id) => `capital-asset-row-${id}`,
  capitalSiteRow: (name) => `capital-site-row-${name}`,
  capitalGroupRow: (name) => `capital-group-row-${name}`,
  capitalSearch: "capital-search-input",
  capitalHorizonFilter: "capital-horizon-filter",
  capitalGroupFilter: "capital-group-filter",
  capitalSiteFilter: "capital-site-filter",
  capitalExportBoard: "capital-export-board-button",
  capitalShareOpen: "capital-share-open-button",
  capitalShareCreate: "capital-share-create-button",
  capitalShareCopy: (token) => `capital-share-copy-${token}`,
  capitalShareRevoke: (token) => `capital-share-revoke-${token}`,
  capitalShareExpiry: "capital-share-expiry-input",
  capitalShareLabel: "capital-share-label-input",
  clientPortalPrint: "client-portal-print-button",

  // HR
  hrLibraryCard: (id) => `hr-library-${id}`,
  hrDocRow: (id) => `hr-doc-${id}`,
  hrBack: "hr-back-button",

  // Spreadsheets
  spreadsheetRow: (id) => `spreadsheet-row-${id}`,
  spreadsheetOpen: (id) => `spreadsheet-open-${id}`,

  // Settings / Integrations
  integrationCard: (p) => `integration-card-${p}`,
  integrationConnect: (p) => `integration-connect-${p}`,
  integrationSave: (p) => `integration-save-${p}`,
  integrationDisconnect: (p) => `integration-disconnect-${p}`,

  // Security / 2FA
  security2FAEnable: "security-2fa-enable-button",
  security2FADisable: "security-2fa-disable-button",
  security2FAVerify: "security-2fa-verify-button",
  security2FAVerifyInput: "security-2fa-verify-input",

  // CRM / Client Management (Phase 2)
  navCRM: "nav-crm-link",
  crmClientRow: (id) => `crm-client-row-${id}`,
  crmSearch: "crm-search-input",
  crmCreateOpen: "crm-create-open-button",
  crmCreateName: "crm-create-name-input",
  crmCreatePortalTier: "crm-create-portal-tier-select",
  crmCreateSubmit: "crm-create-submit-button",
  crmTab: (t) => `crm-tab-${t}`,
  crmDetailClose: "crm-detail-close-button",

  // Audit
  navAudit: "nav-audit-link",
  auditRow: (id) => `audit-row-${id}`,

  // Notifications
  notifBell: "notif-bell-button",
  notifItem: (id) => `notif-item-${id}`,
  notifMarkAll: "notif-mark-all-button",

  // AI Assistant
  aiOpen: "ai-open-button",
  aiSend: "ai-send-button",
  aiInput: "ai-input",

  // Finance (Phase 3)
  financeFYSelect: "finance-fy-select",
  financeBUSelect: "finance-bu-select",
  financeBudgetInput: "finance-budget-input-button",
  financeBudgetSave: "finance-budget-save-button",

  // Performance / QMS (Phase 3)
  navPerformance: "nav-performance-link",
  perfFYSelect: "perf-fy-select",
  perfBUSelect: "perf-bu-select",
  perfTab: (t) => `perf-tab-${t}`,
  perfWhatIfRun: "perf-whatif-run-button",
  perfConfigSave: "perf-config-save-button",

  // Feedback module
  navFeedback: "nav-feedback-link",
  fbCreateOpen: "fb-create-open-button",
  fbCreateType: "fb-create-type-select",
  fbCreateSubject: "fb-create-subject-input",
  fbCreateSubmit: "fb-create-submit-button",
  fbRow: (id) => `fb-row-${id}`,
  fbResolve: (id) => `fb-resolve-${id}`,

  // HSEQ (Phase 6)
  navHSEQ: "nav-hseq-link",
  hseqTab: (t) => `hseq-tab-${t}`,
  hseqBUSelect: "hseq-bu-select",
  hseqFYSelect: "hseq-fy-select",
  hseqCreateOpen: "hseq-create-open-button",
  hseqCreateSubmit: "hseq-create-submit-button",
  hseqCreateCategory: "hseq-create-category-select",
  hseqCreateClassification: "hseq-create-classification-select",
  hseqCreateLocation: "hseq-create-location-input",
  hseqCreateDescription: "hseq-create-description-input",
  hseqCreateDate: "hseq-create-date-input",
  hseqIncidentRow: (id) => `hseq-incident-row-${id}`,
  hseqTileCard: (code) => `hseq-tile-${code}`,
  hseqAuditRow: (id) => `hseq-audit-row-${id}`,
  hseqSwmsRow: (id) => `hseq-swms-row-${id}`,
  hseqActionRow: (id) => `hseq-action-row-${id}`,
  hseqSyncAudits: "hseq-sync-audits-button",

  // Sustainability (Phase 6b)
  sustTab: (t) => `sust-tab-${t}`,
  sustAmpolImportOpen: "sust-ampol-import-open",
  sustAmpolFileInput: "sust-ampol-file-input",
  sustAmpolReportMonth: "sust-ampol-report-month",
  sustAmpolImportSubmit: "sust-ampol-import-submit",
  sustAmpolReportRow: (id) => `sust-ampol-report-row-${id}`,
  sustHabitatRow: (id) => `sust-habitat-row-${id}`,
  fleetWorstRow: (rego) => `fleet-worst-${rego}`,
  fleetVehicleRow: (rego) => `fleet-vehicle-${rego}`,

  // Documents (Phase 10)
  navDocuments: "nav-documents-link",
  docsUploadOpen: "docs-upload-open-button",
  docsUploadSubmit: "docs-upload-submit-button",
  docsUploadFileInput: "docs-upload-file-input",
  docsUploadTitle: "docs-upload-title-input",
  docsUploadType: "docs-upload-type-select",
  docsUploadExpiry: "docs-upload-expiry-input",
  docsSearch: "docs-search-input",
  docsFilterType: "docs-filter-type-select",
  docsTreeNode: (kind, id) => `docs-tree-${kind}-${id}`,
  docsRow: (id) => `docs-row-${id}`,
  docsDelete: (id) => `docs-delete-${id}`,
  docsDownload: (id) => `docs-download-${id}`,

  // Contracts (Section 12, Slice 4)
  navContracts: "nav-contracts-link",
  contractsStatCard: (k) => `contracts-stat-${k}`,
  contractsCreateOpen: "contracts-create-open-button",
  contractsCreateSubmit: "contracts-create-submit-button",
  contractsCreateName: "contracts-create-name-input",
  contractsCreateClient: "contracts-create-client-input",
  contractsCreateEndDate: "contracts-create-end-date-input",
  contractsCreateAnnualValue: "contracts-create-annual-value-input",
  contractsCreateType: "contracts-create-type-select",
  contractsCreateRenewalOwner: "contracts-create-owner-input",
  contractsSearch: "contracts-search-input",
  contractsFilterStatus: "contracts-filter-status-select",
  contractsFilterType: "contracts-filter-type-select",
  contractsRow: (id) => `contracts-row-${id}`,
  contractsDelete: (id) => `contracts-delete-${id}`,
  contractsRenewOpen: (id) => `contracts-renew-open-${id}`,
  contractsRenewSubmit: "contracts-renew-submit-button",
  contractsDraftEmail: (id) => `contracts-draft-email-${id}`,
  contractsDraftEmailCopy: "contracts-draft-email-copy-button",
  contractsPdfImportOpen: "contracts-pdf-import-open-button",
  contractsPdfImportFile: "contracts-pdf-import-file-input",
  contractsPdfImportSubmit: "contracts-pdf-import-submit-button",
  contractsPdfImportUse: "contracts-pdf-import-use-button",

  // Sales & Estimating (Section 11, Slice 4)
  navSales: "nav-sales-link",
  salesStatCard: (k) => `sales-stat-${k}`,
  salesCreateOpen: "sales-create-open-button",
  salesCreateSubmit: "sales-create-submit-button",
  salesRow: (id) => `sales-row-${id}`,
  salesStageSelect: (id) => `sales-stage-${id}`,
  salesNextActionOpen: (id) => `sales-next-action-${id}`,
  salesNextActionCopy: "sales-next-action-copy-button",

  // Reports (Section 16, Slice 4)
  navReports: "nav-reports-link",
  reportsRow: (id) => `reports-row-${id}`,
  reportsRun: (id) => `reports-run-${id}`,
  reportsHistoryRow: (id) => `reports-history-row-${id}`,
};
